module.exports = import("//unpkg.com/mathlive");;